import { $fetch } from '@/plugins/Fetch'

export default {
  methods: {
    BrandListApi (query) {
      return $fetch('common/brand', {
        method: 'GET',
        body: query,
      })
    },
    // 内容列表 boss
    ContentListBossApi (query) {
      return $fetch('content/boss', {
        method: 'GET',
        body: query,
      })
    },
    // 内容列表
    ContentListApi (query) {
      return $fetch('content/contents', {
        method: 'GET',
        body: query,
      })
    },
    // 内容-创建
    ContentCreateApi (query) {
      return $fetch('content/contents', {
        method: 'POST',
        body: query,
      })
    },
    // 内容-更新
    ContentUpdateApi (query) {
      return $fetch(`content/contents/${query.id}`, {
        method: 'PUT',
        body: query,
      })
    },
    // 内容-详情
    ContentDetailApi (query) {
      return $fetch(`content/contents/${query.id}`, {
        method: 'GET',
        body: query,
      })
    },
    // 内容-删除
    ContentDeleteApi (query) {
      return $fetch(`content/contents/${query.id}`, {
        method: 'DELETE',
        body: query,
      })
    },


    // 创建活动管理
    CreateActivityApi (body) {
      return $fetch('activity/create_new', {
        method: 'POST',
        body,
      })
    },
    // 删除活动管理
    DeleteActivityApi (body) {
      return $fetch('activity/delete', {
        method: 'POST',
        body,
      })
    },
    // 活动管理上下架
    ChangeOpenActivityApi (body) {
      return $fetch('activity/change_open', {
        method: 'POST',
        body,
      })
    },
    // 活动管理列表
    GetActivityListApi (body) {
      return $fetch('activity/list', {
        method: 'GET',
        body,
      })
    },
    // 活动管理导出报名用户
    ExportActivityCustomerApi (body) {
      return $fetch('activity/activity_customer_export', {
        method: 'GET',
        body,
      })
    },
    // 活动管理导出订单
    ExportActivityOrderApi (body) {
      return $fetch('activity_order_export', {
        method: 'GET',
        body,
      })
    },
    // 活动管理报名用户列表
    GetActivityCustomerListApi (body) {
      return $fetch('activity/activity_customer', {
        method: 'GET',
        body,
      })
    },
    // 活动管理数据统计
    GetactivityStatisticApi (body) {
      return $fetch('activity/statistic', {
        method: 'GET',
        body,
      })
    },
    // 活动管理订单数据统计
    GetactivityOrderStatisticApi (body) {
      return $fetch('activity/order_statistic', {
        method: 'GET',
        body,
      })
    },
    // 活动管理详情
    GetActivityDetailApi (body) {
      return $fetch('activity/detail', {
        method: 'GET',
        body,
      })
    },
    // 编辑活动管理
    SetActivityEditApi (body) {
      return $fetch('activity/edit', {
        method: 'POST',
        body,
      })
    },
    // 活动管理平台活动列表
    GetActivityBossListApi (body) {
      return $fetch('activity/boss_list', {
        method: 'GET',
        body,
      })
    },
    // 活动管理平台活动详情
    GetActivityBossDetailApi (body) {
      return $fetch('activity/boss_detail', {
        method: 'GET',
        body,
      })
    },
    // 助力活动数据统计 activity/help_statistic
    helpStatisticDetailApi (body) {
      return $fetch('activity/help_statistic', {
        method: 'POST',
        body,
      })
    },
    // 助力记录列表 activity/help_launch_list
    helpListApi (body) {
      return $fetch('activity/help_launch_list', {
        method: 'GET',
        body,
      })
    },
    GetTemplateCategoryApi () {
      return $fetch('activity_store/template_category', {
        method: 'GET',
      })
    },
    // 中央活动库列表（模板活动列表）
    GetActivityStoreBossListApi (body) {
      return $fetch('activity_store/boss_list', {
        method: 'GET',
        body,
      })
    },
    // 中央活动库详情
    GetActivityStoreBossDetailApi (body) {
      return $fetch('activity_store/boss_detail', {
        method: 'GET',
        body,
      })
    },
    // 添加中央活动库活动到门店
    SetActivityStoreAdd (body) {
      return $fetch('activity_store/add', {
        method: 'POST',
        body,
      })
    },
    // 删除模板活动
    DeleteActivityStoreApi (body) {
      return $fetch('activity_store/delete', {
        method: 'GET',
        body,
      })
    },
    // 模板活动上下架
    ChangeOpenActivityStoreApi (body) {
      return $fetch('activity_store/up_down', {
        method: 'GET',
        body,
      })
    },
    // 检查活动关联关系（检查配置的优惠券是否发生改变）
    checkRelationApi (body) {
      return $fetch('activity_store/check_relation', {
        method: 'GET',
        body,
      })
    },
    // 编辑中央活动库活动到门店
    SetActivityStoreUpdateApi (body) {
      return $fetch('activity_store/update', {
        method: 'POST',
        body,
      })
    },
    // 获取活动二维码
    GetActivityStoreQrCodeApi (body) {
      return $fetch('activity_store/qr_code', {
        method: 'GET',
        body,
      })
    },
    // 获取活动详情（模板活动）
    GetActivityStoreDetailApi (body) {
      return $fetch('activity_store/detail', {
        method: 'GET',
        body,
      })
    },
    // 模板活动数据统计（模板活动）
    GetActivityStatisticTemplateApi (body) {
      return $fetch('activity_store/statistic', {
        method: 'GET',
        body,
      })
    },
    // 模板活动员工数据统计
    GetActivityStatisticMemberApi (body) {
      return $fetch('activity_store/member_statistic', {
        method: 'GET',
        body,
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/modules/Content.js